import React from 'react'

import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
// USE THE IMPORT BELOW INSTEAD IF YOU ARE USING THE PRO VERSION
// import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox-pro'
import lightBoxOptions from '../data/LightBoxOptions';

function WorkGallery(props){

    const { galleryImage } = props
    
    return(

        galleryImage.length === 0 ? null
        :
        <section id="workGallery" className="section project-images">
            <p className="gallery-title anim-bot">PHOTO GALLERY</p>
            <SimpleReactLightbox>
                <SRLWrapper options={lightBoxOptions}>
                    <div className="container-fluid-small">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 gallery-image-box">
 
                                {galleryImage.map((item, index) => <a href={`/oitid/student/assets/images/${item}`} className="anim-bot gallery-image"><img src={`/oitid/student/assets/images/${item}`} alt="" /></a>)}

                            </div>
                        </div>
                    </div>
                </SRLWrapper>
            </SimpleReactLightbox>
        </section>

    )

}

export default WorkGallery